define('app/sdc/md/attribute/sdc-md-attribute-factory',["factory!sdc-bound-expression"], function (boundExpression) {
	"use strict";
	return sdcMdAttributeFactory;
	function sdcMdAttributeFactory(classMap, formatter, addDirectiveAsClass) {
		if (!angular.isObject(classMap)) {
			classMap = {
				"default": classMap,
				"sm": classMap + "-sm",
				"gt-sm": classMap + "-gt-sm",
				"md": classMap + "-md",
				"gt-md": classMap + "-gt-md",
				"lg": classMap + "-lg",
				"gt-lg": classMap + "-gt-lg",
			};
		}
		return {
			restrict: "A",
			template: null,
			scope: false,
			controller: null,
			link: ["$name", "$scope", "$element", "$attrs", "$watch", function ($name, $scope, $element, $attrs, $watch) {
				var $old;
				$watch($attrs[$name], onChange, true);

				function onChange($new) {
					$new = formatter($new);
					angular.forEach($old, function (val, key) {
						var className = classMap[key];
						if (addDirectiveAsClass && (!angular.isObject($new) || !Object.hasOwnProperty.call($new, key))) {
							$element.removeClass(className);
						}

						if ((val === 0 || val) && (!angular.isObject($new) || val !== $new[key])) {
							$element.removeClass(makeValueClass(className, val));
						}
					});

					angular.forEach($new, function (val, key) {
						var className = classMap[key];
						if (addDirectiveAsClass && (!angular.isObject($old) || !Object.hasOwnProperty.call($old, key))) {
							$element.addClass(className);
						}

						if ((val === 0 || val) && (!angular.isObject($old) || val !== $old[key])) {
							$element.addClass(makeValueClass(className, val))
						}
					});
					$old = $new; 
				}
			}]
		};
	}
	function makeValueClass(className, value) {
		if (value === true || value === false) {
			return className;
		}
		return className + "-" + String(value).replace(/\s+/g, "-");
	}
});
